module.exports = __webpack_public_path__ + "img/resourceBank.98921121.svg";